(function () {
  const STORAGE_KEY = "__theme__recently_products";
  const DEFAULT_SEED_COUNT = 3;

  const initSlider = (section) => {
    const sliderEl = section.querySelector(".js-recently-viewed-slider");
    if (!sliderEl) return;

    const productsPerRow = Number(sliderEl.dataset.productsPerRow || 4);
    const productsPerRowMobile = Number(
      sliderEl.dataset.productsPerRowMobile || 1
    );
    const spaceBetween = Number(sliderEl.dataset.spaceBetween || 1);
    const nextBtn = section.querySelector(
      ".heading-group__navigation-button-next"
    );
    const prevBtn = section.querySelector(
      ".heading-group__navigation-button-prev"
    );
    const slidesPerViewMobile = productsPerRowMobile;
    const slidesPerView576 = productsPerRow > 1 ? 2 : 1;
    const slidesPerView990 =
      productsPerRow > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1200 = productsPerRow >= 4 ? 4 : productsPerRow;
    const slidesPerView1360 = productsPerRow;

    const sliderSettings = {
      slidesPerView: slidesPerViewMobile,
      spaceBetween: spaceBetween,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      breakpoints: {
        576: {
          slidesPerView: slidesPerView576,
        },
        990: {
          slidesPerView: slidesPerView990,
        },
        1200: {
          slidesPerView: slidesPerView1200,
        },
        1360: {
          slidesPerView: slidesPerView1360,
        },
      },
    };

    new Swiper(sliderEl, sliderSettings);
  };

  const destroySlider = (section) => {
    const sliderEl = section.querySelector(".js-recently-viewed-slider");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();
    sliderEl.querySelector(".swiper-wrapper")?.removeAttribute("style");
    sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
      slide.removeAttribute("style");
    });
  };

  const initSectionLayout = (section) => {
    if (!section || !section?.classList.contains("recently-viewed-section")) {
      return;
    }

    const box = section.querySelector(".popular-products");
    if (!box) return;

    const layout = box.dataset.layout || "grid";
    if (layout === "slider") {
      initSlider(box);
    } else {
      destroySlider(box);
    }
  };

  const initSection = async (section) => {
    if (!section || !section?.classList.contains("recently-viewed-section")) {
      return;
    }

    const box = section.querySelector(".recently-viewed");
    if (!box) return;

    const EXPIRATION_DAYS = box.dataset.expirationDays
      ? Number(box.dataset.expirationDays)
      : 30;
    const dateNow = Date.now();

    const recommendationsUrl = box.dataset.recommendationsUrl;
    const productsLimit = Number(box.dataset.productsLimit) || 6;
    const seedCount = Number(box.dataset.seedCount) || DEFAULT_SEED_COUNT;

    if (!recommendationsUrl) {
      box.classList.remove("recently-viewed--loading");
      box.classList.add("recently-viewed--empty");
      return;
    }

    // get recently viewed products from local storage, used as seeds
    let recentProducts = [];
    try {
      recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      console.error(`Incorrect value in local storage for "${STORAGE_KEY}"`);
    }

    // sort newest first, dedupe, drop expired entries
    const expirationTime = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;
    const seenSeed = new Set();
    const seedProducts = recentProducts
      .filter(
        (item) => item.productId && dateNow - item.timestamp < expirationTime
      )
      .sort((a, b) => b.timestamp - a.timestamp)
      .filter((item) => {
        if (seenSeed.has(item.productId)) return false;
        seenSeed.add(item.productId);
        return true;
      })
      .slice(0, seedCount);

    if (seedProducts.length === 0) {
      box.classList.remove("recently-viewed--loading");
      box.classList.add("recently-viewed--empty");
      return;
    }

    const seedIds = new Set(seedProducts.map((item) => String(item.productId)));

    try {
      // fetch Shopify's product recommendations for each recently viewed seed product
      const responses = await Promise.all(
        seedProducts.map((item) =>
          fetch(`${recommendationsUrl}&product_id=${item.productId}`)
            .then((response) => (response.ok ? response.text() : null))
            .catch(() => null)
        )
      );

      const parser = new DOMParser();
      const seenProducts = new Set();
      const mergedItems = [];

      responses.forEach((html) => {
        if (!html) return;
        const doc = parser.parseFromString(html, "text/html");
        const list = doc.querySelector(".popular-products__list");
        if (!list) return;

        list.querySelectorAll(".popular-products__item").forEach((item) => {
          const productId = item.querySelector("product-card")?.dataset
            .productId;
          if (!productId || seenProducts.has(productId) || seedIds.has(productId)) {
            return;
          }
          seenProducts.add(productId);
          mergedItems.push(item);
        });
      });

      if (mergedItems.length === 0) {
        box.classList.add("recently-viewed--empty");
        return;
      }

      const targetList = box.querySelector(".popular-products__list");
      if (!targetList) {
        box.classList.add("recently-viewed--empty");
        return;
      }

      targetList.innerHTML = "";
      mergedItems.slice(0, productsLimit).forEach((item) => {
        targetList.appendChild(item);
      });

      initSectionLayout(section);
    } catch (error) {
      console.error("Failed to fetch personalized recommendations:", error);
      box.classList.add("recently-viewed--empty");
    } finally {
      box.classList.remove("recently-viewed--loading");
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
